import { Injectable } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { UserServiceProvider } from '@services/user/user.service';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';
import { AccountServiceProvider } from '@services/user/account.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PromoCodeProvider {
	updateSubscriprtionPrice: Subject<void> = new Subject();

	constructor(
		private messageService: MessageService,
		private userService: UserServiceProvider,
		private timeService: TimeServiceProvider,
		private accountService: AccountServiceProvider
	) {}

	get updateSubscriptionPriceObservable(): Observable<any> {
		return this.updateSubscriprtionPrice.asObservable();
	}

	successApplyPromoCode(subscription): void {
		const updatedUser = JSON.parse(
			JSON.stringify(this.userService.userData),
			this.timeService.parseDateFromJSON
		);

		updatedUser.subscriptionPrice = subscription;
		updatedUser.promocodeEnabled = true;

		this.accountService.emitUser(updatedUser);

		const updatedSubscriptionData = JSON.parse(
			JSON.stringify(this.userService.subscriptionData)
		);
		const isAnnualPromoOrDiscountEnabled =
			updatedUser.subscriptionPrice.annualDiscountPrice >= 0;
		const isMonthlyPromoOrDiscountEnabled =
			updatedUser.subscriptionPrice.monthlyDiscountPrice >= 0;

		updatedSubscriptionData.annualPromo = isAnnualPromoOrDiscountEnabled;
		updatedSubscriptionData.monthlyDiscount = isAnnualPromoOrDiscountEnabled;
		updatedSubscriptionData.annualDiscount = isAnnualPromoOrDiscountEnabled;
		updatedSubscriptionData.monthlyPromo = isMonthlyPromoOrDiscountEnabled;

		this.accountService.emitSubscriptionInfo(updatedSubscriptionData);
		this.updateSubscriprtionPrice.next();
	}

	errorApplyPromoCode({ data, status }): void {
		const errorMessage = data ? data.errorMessage : null;
		let errorCode, errorPlace, value;
		if (errorMessage && status >= 400 && status < 500) {
			if (
				errorMessage === 'Promo code is expired or inactive' ||
				errorMessage === "You can't use your promo code"
			) {
				errorCode = 'e_0';
				errorPlace = 'promoCodes';
			} else if (errorMessage.includes('Can not find promo code')) {
				errorCode = 'e_1';
				errorPlace = 'promoCodes';
			} else {
				errorCode = 'e_2';
				errorPlace = 'general';
				value = errorMessage;
			}
		} else {
			errorCode = 'e_0';
			errorPlace = 'general';
		}
		this.messageService.showToaster(errorCode, errorPlace, value);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/subscription/promo-code.service.ts